import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from '../../../../assets/images/LogoWithText.svg';

interface LogoProp {
  lang: string;
}

export const Logo: FC<LogoProp> = ({ lang }) => {
  return (
    <div className="logo-container">
      <Link to={{ pathname: `${process.env.REACT_APP_BRIZ_MAIN_URL}${lang === 'ua' ? '' : lang}` }} target="_blank">
        <LogoIcon className="logo-container__icon" />
      </Link>
    </div>
  );
};
